import React from 'react';
export const TargetAudience: React.FC = () => {
  const items = ['Querés un negocio que podés arrancar con menos de USD 200', 'Te interesa el oro pero no sabés por dónde empezar', 'Querés aprender a identificar piezas reales del falso', 'Buscás un ingreso extra que no dependa de redes ni de ser influencer', 'Vivís en Argentina y querés aprovechar el mercado del dólar blue', 'Ya comprás o vendés pero sentís que te falta conocimiento técnico', 'Querés un sistema probado, no "ideas sueltas" de YouTube'];
  return <section className="py-20" data-id="element-176">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-177">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-178">
          Esta guía es para vos si
          <span style={{
          color: 'var(--gold)'
        }} data-id="element-179">
            …
          </span>
        </h2>

        <ul className="max-w-2xl mx-auto" data-id="element-180">
          {items.map((item, index) => <li key={index} className="py-4 pl-10 relative text-base" style={{
          color: 'var(--text-secondary)',
          borderBottom: index < items.length - 1 ? '1px solid var(--border-subtle)' : 'none'
        }} data-id="element-181">
              <span className="absolute left-0 text-xl" style={{
            color: 'var(--gold)'
          }} data-id="element-182">
                ☐
              </span>
              {item}
            </li>)}
        </ul>

        <div className="mt-8 text-center p-5 rounded-lg border border-dashed font-medium" style={{
        borderColor: 'var(--border-gold)',
        color: 'var(--gold-light)'
      }} data-id="element-183">
          Si marcaste 3 o más, esta guía fue pensada para vos.
        </div>
      </div>
    </section>;
};